var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from "@core/views";
var UserCreateView = /** @class */ (function (_super) {
    __extends(UserCreateView, _super);
    function UserCreateView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserCreateView.prototype.onMounted = function () {
        document.getElementById('section_organization_groups').style.display = 'none';
        document.getElementById('section_cb_internal').style.display = 'none';
        document.getElementById('id_groups_2').disabled = true;
        document.getElementById('id_excel_allowed').disabled = true;
        document.getElementById('id_get_error_notifications').disabled = true;
        document.getElementById('id_is_superuser').disabled = true;
    };
    /**
     *
     * @param inputElement
     */
    UserCreateView.prototype.externalSelectionChanged = function (inputElement) {
        var checked = inputElement.checked;
        document.getElementById('id_groups_0').checked = false;
        document.getElementById('id_groups_1').checked = false;
        document.getElementById('id_groups_2').checked = false;
        document.getElementById('id_groups_0').disabled = checked;
        document.getElementById('id_groups_1').disabled = checked;
        document.getElementById('id_groups_2').disabled = !checked;
        document.getElementById('id_excel_allowed').checked = false;
        document.getElementById('id_get_error_notifications').checked = false;
        document.getElementById('id_is_superuser').checked = false;
        document.getElementById('id_get_error_notifications').disabled = true;
        document.getElementById('id_is_superuser').disabled = true;
    };
    /**
     * OnClick-listener for "Select all"-button
     * @param inputElement
     */
    UserCreateView.prototype.inputFieldValueChanged = function (inputElement) {
        var username = document.getElementById('id_username').value.length;
        var email = document.getElementById('id_email').value.length;
        var admin = document.getElementById('id_groups_0');
        var sales = document.getElementById('id_groups_1');
        var production = document.getElementById('id_groups_2');
        document.getElementById('id_excel_allowed').checked = false;
        document.getElementById('id_get_error_notifications').checked = false;
        document.getElementById('id_is_superuser').checked = false;
        if (inputElement === admin) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_get_error_notifications').disabled = !inputElement.checked;
            document.getElementById('id_is_superuser').disabled = !inputElement.checked;
        }
        else if (inputElement === sales) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_get_error_notifications').disabled = !inputElement.checked;
            document.getElementById('id_is_superuser').disabled = !inputElement.checked;
        }
        else if (inputElement === production) {
            document.getElementById('id_excel_allowed').disabled = !inputElement.checked;
            document.getElementById('id_get_error_notifications').disabled = true;
            document.getElementById('id_is_superuser').disabled = true;
        }
        else {
            document.getElementById('section_cb_internal').style.display = (username > 0 && email > 0) ? 'initial' : 'none';
            document.getElementById('section_organization_groups').style.display = (username > 0 && email > 0) ? 'initial' : 'none';
        }
    };
    return UserCreateView;
}(View));
export default UserCreateView;
